module.exports = "pegasus_template/assets/custom-2-google.png";